import React, {useEffect, useState} from "react";
import {
    Button,
    MenuItem,
    HTMLTable,
    NonIdealState,
    InputGroup,
    Section,
    SectionCard,
    Tag,
    HTMLSelect, Card, Intent, Alert
} from "@blueprintjs/core";
import myAxios from "../../myAxios";
import {loadingState} from "../../recoil/loadingState";
import {useRecoilValue, useSetRecoilState} from 'recoil';
import {useNavigate, useParams} from "react-router-dom";
import {alertState} from "../../recoil/alertState";
import UserInfoComp from "../../element/UserInfoComp";
import {isMobileState} from "../../recoil/isMobileState";

export default function UserAdminPage() {

    const { id } = useParams();
    let navigate = useNavigate();

    const [isPopup, setPopup] = useState(false)
    const [user, setUser] = useState({address2: '', emailDuplicated: null})
    const setLoading = useSetRecoilState(loadingState);
    const setAlert = useSetRecoilState(alertState);
    const isMobile = useRecoilValue(isMobileState);

    useEffect(() => {
        setLoading({active: true, text: '회원 정보를 불러오는 중입니다...'})

        myAxios.get(`/admin/user/${id}`).then((res) => {
            setUser(res.data)
        }).finally(()=>setLoading({active: false}))
    }, []);

    return (
        <>
            <div style={{
                width: '100%',
                padding: isMobile ? '5px' : '15px',
                gap: isMobile ? 10 : 15,
                display: 'grid',
                alignContent: 'start',
                gridTemplateAreas: isMobile ?
                    `'a''b''c''d'`
                    :
                    `'a a a a a c'
                    'b b b b b c'
                    'd d d d d d'`
            }}>
                <UserInfoComp user={user} setUser={setUser} type={'admin'}/>

                <Card style={{gridArea: 'd'}}>

                    <Button icon={'arrow-left'} text={'뒤로가기'} style={{float:'left'}}
                            onClick={() => {window.history.back()}}
                    />

                    <div style={{display: 'flex', justifyContent: 'flex-end', gap:20}}>
                        <Button intent={'danger'} icon={'warning-sign'} text={'회원탈퇴'}
                                onClick={() => setPopup(true)}/>
                        <Alert
                            cancelButtonText="취소"
                            confirmButtonText="탈퇴"
                            icon="delete"
                            intent={'danger'}
                            isOpen={isPopup}
                            onClose={() => setPopup(false)}
                            onConfirm={() => {
                                setLoading({active: true, text: "탈퇴 중 입니다..."})
                                myAxios.delete(`/admin/user/${id}`)
                                    .then(()=>window.history.back())
                                    .finally(()=>setLoading({active: false}));
                            }}
                        >
                            <p>
                                해당 유저를 탈퇴시키겠습니까? 탈퇴 이후에는 해당 계정을 사용할 수 없습니다.
                            </p>
                        </Alert>

                        <Button
                            intent={'success'} icon={'edit'} text={'정보수정'}
                            disabled={!(user.name && user.email && user.emailDuplicated === false && user.phoneNumber && user.desiredRole)}
                            onClick={() => {
                                setLoading({active: true, text: "작업 중 입니다..."})

                                myAxios.patch(`/admin/user/${id}`, {
                                    ...user, ...(!user?.branch?.id && {branch:{id:null}})
                                }).then((res) => {
                                    setAlert({
                                        active: true,
                                        text: '수정이 완료되었습니다.',
                                        confirmButtonText: '확인'
                                    });
                                }).finally(() => {
                                    setLoading({active: false})
                                })

                            }}/>
                    </div>
                </Card>

            </div>
        </>
    );
}